import React from 'react';
import PropTypes from 'prop-types';

const Status = ({ asset }) => {
  const statusMap = {
    approved: t('Approved'),
    pending_approval: t('Pending approval'),
    unpublished: t('Draft'),
    expired: t('Expired')
  };

  const { availability, availability_end, availability_start } = asset.attributes;
  let statusModifier;

  if (availability !== 'unpublished' && availability !== 'expired') {
    if (availability_start && new Date(availability_start) > new Date()) {
      statusModifier = t('and unpublished');
    }

    if (availability_end && new Date(availability_end) < new Date()) {
      statusModifier = t('and expired');
    }
  }

  return (
    <div className="status-container">
      <p>
        {t('Current status:')}
        <span className="status">{statusMap[availability] || t('Available')}</span>
        <span className="status-modifier">{statusModifier}</span>
      </p>
      <hr />
    </div>
  );
};

Status.propTypes = {
  asset: PropTypes.shape({
    attributes: PropTypes.shape({
      availability: PropTypes.string,
      availability_end: PropTypes.string,
      availability_start: PropTypes.string,
    })
  }).isRequired,
};

export default Status;
